import {Component, inject} from '@angular/core';
import {TableModule} from 'primeng/table';
import {SharedModule, TreeNode} from 'primeng/api';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {BaseNodeGridComponent} from '../../base-components/base-node-grid.component';
import {TreeHelperService} from '../../../service/helper/tree-helper.service';
import {CantaaErrorHandlerService} from '../../../service/cantaa-error-handler.service';
import {WimTreeNode} from '../../../model/wim-tree.node';
import {NodeType} from '../../../constants/node-type';
import {WimIcons} from '../../../constants/wim-icons';
import {ProjectListItem} from '../../../model/project-list.item';
import {ProjectService} from '../../../service/project.service';
import {RouteType} from '../../../constants/route-type';
import {CantaaMessageService} from '../../../service/cantaa-message.service';
import {Permission} from '../../../constants/Permission';
import {HasPermissionDirective} from '../../../directive/has-permission.directive';
import {UuidHelperService} from '../../../service/helper/uuid-helper.service';
import {TranslateModule} from '@ngx-translate/core';
import {GridRequest} from '../../../model/grid-request.model';
import {ShowIfDebugMode} from "../../../directive/show-if-debug.directive";
import {DatePipe} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'wim-project-grid',
  templateUrl: './project-grid.component.html',
  styleUrl: './project-grid.component.scss',
  standalone: true,
  imports: [
    SharedModule,
    TableModule,
    MatButton,
    MatIcon,
    HasPermissionDirective,
    TranslateModule,
    ShowIfDebugMode,
    DatePipe,
    DropdownModule,
    FormsModule
  ]
})
export class ProjectGridComponent extends BaseNodeGridComponent<ProjectListItem> {
  protected readonly Permission = Permission;
  protected override nodeTypes = [NodeType.PROJECT_RELATION];

  private treeHelperService = inject(TreeHelperService);
  private errorHandler = inject(CantaaErrorHandlerService);
  private messageService = inject(CantaaMessageService);
  private projectService = inject(ProjectService);

  protected statusOptions: { label: string, value: string }[] = [];

  override ngOnInit() {

    super.ngOnInit();

    this.translate.get(['ACTIVE', 'DELETED', 'TERMINATED']).subscribe(translations => {
      this.statusOptions = [
        { label: translations['ACTIVE'], value: 'ACTIVE' },
        { label: translations['DELETED'], value: 'DELETED' },
        { label: translations['TERMINATED'], value: 'TERMINATED' },
      ];
    });
  }

  override mapTreeItems(selectedNode: WimTreeNode, items: ProjectListItem[]): WimTreeNode[] {
    return items
      .map<WimTreeNode>(listItem => {

        let treeNode = {
          id: listItem.id,
          key: UuidHelperService.generateUuid(),
          // label: listItem.number,
          label: `${listItem.projectType} ${listItem.number}`,
          data: `${listItem.id}`,
          icon: WimIcons.PROJECT_ICON,
          nodeType: NodeType.PROJECT,
          route: RouteType.PROJECT,
          children: [] as TreeNode[],
          leaf: false,
          parent: selectedNode
        };
        listItem.treeNode = treeNode;

        treeNode.children = [
          this.treeHelperService.createToolRelationsTreeItem(treeNode),
          this.treeHelperService.createEmployeeRelationsTreeItem(treeNode),
          this.treeHelperService.createMobileLocationRelationsTreeItem(treeNode),
        ];
        return treeNode;
      });
  }

  override async fetchGridItems(gridRequest: GridRequest, selectedNode: WimTreeNode) {
    try {
      return await this.projectService.getProjects(gridRequest, selectedNode);
    } catch (e) {
      this.errorHandler.handleError(e, 'FAILED_TO_FETCH');
      throw e;
    }
  }

  async delete() {
    try {
      await this.projectService.deleteProject(this.selectedItem);
      this.messageService.success('DELETE.SUCCESS');
      await this.reFetchData();
    } catch (e) {
      this.errorHandler.handleError(e, 'DELETE.FAILED');
      throw e;
    }
  }
}



